export default "__VITE_ASSET__CjAS4Ujn__"